import { EtTransaction } from "../../../types/LandToken";
import { TransactionDetails } from "../../../components/TransactionDetails";
import { styled } from "@mui/material";
import { useState } from "react";

export const TxnHashCell = ({ item }: { item: EtTransaction }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<EtTransaction | null>(null);

  const selectTxn = (item: EtTransaction) => {
    setSelectedTransaction(item);
    setDetailsOpen(true);
  };
  const handleCloseDetails = () => {
    setDetailsOpen(!detailsOpen);
  };

  const hash = "0x" + item.hash.slice(2).toUpperCase();

  return (
    <>
      <StyledLink style={{ width: "130px" }} onClick={() => selectTxn(item)}>
        {hash}
      </StyledLink>
      {selectedTransaction && (
        <TransactionDetails txn={selectedTransaction} open={detailsOpen} onClose={() => handleCloseDetails()} />
      )}
    </>
  );
};

const StyledLink = styled("div")`
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  font-family: IBM Mono, monospace;
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-bottom: 6px;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }
  width: max-content;
`;
